import { ChangeDetectorRef } from '@angular/core';
import { NFormComponent } from '@pebula/nform';

/**
 * Validates an NForm and displays validation errors in the UI.
 * Call this before form submission to ensure users see all validation errors.
 *
 * @param nForm - The NForm component to validate
 * @param cdr - ChangeDetectorRef for triggering UI updates
 * @returns true if valid, false if invalid (with errors displayed)
 *
 * @example
 * if (!validateNFormAndShowErrors(this.myForm, this.cdr)) {
 *   return; // Form is invalid, errors are now visible
 * }
 * // Continue with form submission
 */
export function validateNFormAndShowErrors<T>(nForm: NFormComponent<T> | undefined, cdr: ChangeDetectorRef): boolean {
  if (!nForm || !nForm.form.valid) {
    nForm?.form.markAllAsTouched();

    // Force each control to update its validity state so the renderer displays errors
    Object.keys(nForm?.form?.controls || {}).forEach((key) => {
      nForm.form.get(key)?.updateValueAndValidity();
    });

    cdr.detectChanges();
    return false;
  }
  return true;
}
